(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tape-slideshow"] && !Shopify.designMode) return;
  try {
    
// Ensure the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function() {
  // Wait until jQuery is defined
  var checkJQuery = setInterval(function() {
    if (typeof jQuery != "undefined" && typeof jQuery().slick != "undefined") {
      clearInterval(checkJQuery);
      $('.tape-slideshow').slick({
        autoplay: true,
        autoplaySpeed: 7000,
        dots: true,
        arrows: false, // Arrows disabled
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  }, 100);
});

  } catch(e) { console.error(e); }
})();
})();
